import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import "./Modal.css";
import useLockBodyScroll from "@/hooks/useBodyLockScroll";
import closeIcon from "@/assets/svgs/close.svg";
import Image from "next/image";
import useIsMobile from "@/hooks/useIsMobile";

function Modal({
  isVisible,
  label,
  children,
  onClose,
  removeHeader,
  imageLeft,
  maxWidth = "512px",
  removePadding = false,
  removeBodyPadding = false,
  footer = "",
  disableBackDropClose = false,
  disableClose = false,
  notificationModal,
  backgroundColor,
}) {
  /* ───────── enter / exit logic ───────── */
  const [render, setRender] = useState(isVisible); // keep in DOM?
  const [entered, setEntered] = useState(false); // add .enter class

  useLockBodyScroll(render);
  const isMobile = useIsMobile();

  /* sync with parent prop */
  useEffect(() => {
    if (isVisible) {
      setRender(true);
      let enterFrame = null;
      const mountFrame = requestAnimationFrame(() => {
        enterFrame = requestAnimationFrame(() => setEntered(true));
      });

      return () => {
        cancelAnimationFrame(mountFrame);
        if (enterFrame !== null) cancelAnimationFrame(enterFrame);
      };
    }
    setEntered(false); // start exit css
    const t = setTimeout(() => setRender(false), 300); // = CSS duration
    return () => clearTimeout(t);
  }, [isVisible]);

  if (!render) return null;

  /* helpers */
  const backDropClose = () => !disableBackDropClose && onClose?.();

  /* markup */
  const modalMarkup = (
    <div className={`Modal ${entered ? "enter" : ""}`}>
      <div className="Modal-backdrop" onClick={backDropClose} />
      <div
        className="Modal-content"
        style={{ maxWidth }}
        role="dialog"
        aria-modal="true"
        aria-label={label || undefined}
      >
        {imageLeft && !isMobile && (
          <Image src={imageLeft} alt="" className="Modal-left-image" />
        )}

        <div
          className={`Modal-content-wrapper ${
            notificationModal ? "notificationModal" : ""
          }`} //different background color if true
          style={{
            padding: removePadding ? 0 : "60px 24px 24px 24px",
            backgroundColor: backgroundColor ? backgroundColor : "",
          }}
        >
          {!disableClose && (
            <button
              type="button"
              className="Modal-close-wrapper transition"
              onClick={onClose}
              aria-label="Dialog schließen"
            >
              <Image
                src={closeIcon}
                className="Modal-close-icon"
                alt=""
              />
            </button>
          )}

          {!removeHeader && (
            <header className="Modal-header">
              <h1 className="Modal-title">{label}</h1>
            </header>
          )}

          <div
            className={`Modal-body ${removeBodyPadding ? "Modal-body-no-padding" : ""}`}
          >
            {children}
          </div>
          {footer && <footer className="Modal-footer">{footer}</footer>}
        </div>
      </div>
    </div>
  );

  return ReactDOM.createPortal(modalMarkup, document.body);
}

export default Modal;
